import { API_BASE } from '../constants';
import { getData } from '../_base';
import { ProcessDto } from '../../dto/Process';
import { getCurrentLanguageDto } from '../../utilitys/language';

const base = `${API_BASE}/v1/Procedures`;

const url = {
  getByLanguage: `${base}/Procedures`,
  gGetById: `${base}/GetById`,
};

export const getProcessByLangApi = async (): Promise<ProcessDto[]> => {
  const lngDto = getCurrentLanguageDto();
  const _url = `${url.getByLanguage}/${lngDto.id}`;
  const result = await getData<ProcessDto[]>(_url);
  if (result && !result.hasError && result.data ) return result.data;
  else return [];
};


export const getProcessByIdApi = async (id: number): Promise<ProcessDto | undefined> => {
  const _url = `${url.gGetById}/${id}`;
  const result = await getData<ProcessDto>(_url);
  if (result && !result.hasError && result.data ) return result.data;
  else return undefined;
};
